import Vue from "vue";
import Router from "vue-router";
const LoginComponent = () => import(/* webpackChunkName: "page-login" */ "./views/Login.vue");
const SignUpComponent = () => import(/* webpackChunkName: "page-signup" */ "./views/SignUp.vue");
const AccountActivation = () => import(/* webpackChunkName: "page-accountactivation" */ "./views/AccountActivation.vue");
const ResetPasswordComponent = () => import(/* webpackChunkName: "page-resetpassword" */ "./views/ResetPassword.vue");
const Home = () => import(/* webpackChunkName: "page-home" */ "./views/Home.vue");
const Admin = () => import(/* webpackChunkName: "page-admin" */ "./views/Admin.vue");
const DeviceLifecycle = () => import(/* webpackChunkName: "page-devicelifecycle" */ "./views/DeviceLifecycle.vue");
const Person = () => import(/* webpackChunkName: "page-person" */ "./views/Person.vue");
const Location = () => import(/* webpackChunkName: "page-location" */ "./views/Location.vue");
const Contract = () => import(/* webpackChunkName: "page-contract" */ "./views/Contract.vue");
const EnergyUnit = () => import(/* webpackChunkName: "page-energyunit" */ "./views/EnergyUnit.vue");
const Invoice = () => import(/* webpackChunkName: "page-invoice" */ "./views/Invoice.vue");
const Administration = () => import(/* webpackChunkName: "page-administration" */ "./views/Administration.vue");
const Device = () => import(/* webpackChunkName: "page-device" */ "./views/Device.vue");
const Dsgvo = () => import(/* webpackChunkName: "page-dsgvo" */ "./views/Dsgvo.vue");
const User = () => import(/* webpackChunkName: "page-user" */ "./views/User.vue");
const Pricing = () => import(/* webpackChunkName: "page-pricing" */ "./views/Pricing.vue");
const EnergyDashboard = () => import(/* webpackChunkName: "page-energydashboard" */ "./views/EnergyDashboard.vue");
const EnergyOptimizer = () => import(/* webpackChunkName: "page-energyoptimizer" */ "./views/EnergyOptimizer.vue");
const Agents = () => import(/* webpackChunkName: "page-agents" */ "./views/Agents.vue");
const WorkflowStudio = () => import(/* webpackChunkName: "page-workflowstudio" */ "./views/WorkflowStudio.vue");
const ProcessCenter = () => import(/* webpackChunkName: "page-processcenter" */ "./views/ProcessCenter.vue");
const AgentOperations = () => import(/* webpackChunkName: "page-agentoperations" */ "./views/AgentOperations.vue");
const HeatcontrolMultiApartment = () => import(/* webpackChunkName: "page-heatcontrolmultiapartment" */ "./views/HeatcontrolMultiApartment.vue");
const ProjectSetup = () => import(/* webpackChunkName: "page-projectsetup" */ "./views/ProjectSetup.vue");
const SupportSession = () => import(/* webpackChunkName: "page-supportsession" */ "./views/SupportSession.vue");
const Notifications = () => import(/* webpackChunkName: "page-notifications" */ "./views/Notifications.vue");
const MessagingInbox = () => import(/* webpackChunkName: "page-messagingworkspace" */ "./views/MessagingWorkspace.vue");

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    
    {
      path: "/",
      redirect: {
        name: "login"
      }
    },
    {
      path: "/login",
      name: "login",
      component: LoginComponent
    },
    {
      path: "/support-session",
      name: "supportSession",
      component: SupportSession
    },
    {
      path: "/sign-up",
      name: "signUp",
      component: SignUpComponent
    },
    {
      path: "/activate-account/:token?",
      component: AccountActivation,
      name: "accountActivation"
    },
    {
      path: "/reset-password",
      name: "resetPassword",
      component: ResetPasswordComponent
    },
    {
      path: "/confirm-password-reset/:token?",
      name: "resetPasswordConfirm",
      component: ResetPasswordComponent
    },
    {
      path: "/home",
      icon: "insert_chart",
      color: "red darken-2",
      name: "home",
      component: Home
    },
    {
      path: "/admin",
      name: "admin",
      icon: "settings",
      color: "grey darken-2",
      component: Admin
    },
    {
      path: "/device-lifecycle",
      name: "lifecycle",
      icon: "mdi-lan-pending",
      color: "teal darken-2",
      descriptionKey: "lifecycleNavHint",
      component: DeviceLifecycle
    },
    {
      path: "/mqtt-claims",
      redirect: {
        name: "lifecycle",
        query: {
          tab: "claims"
        }
      }
    },
    {
      path: "/mqtt-permissions",
      name: "mqttPermissions",
      redirect: { name: "lifecycle", query: { tab: "permissions" } }
    },
    {
      path: "/person",
      name: "person",
      icon: "account_box",
      color: "deep-orange",
      component: Person
    },
    {
      path: "/loc",
      name: "location",
      icon: "business",
      color: "blue darken-2",
      component: Location
    },
    {
      path: "/project-setup",
      name: "projectSetup",
      icon: "mdi-floor-plan",
      color: "teal darken-2",
      component: ProjectSetup
    },
    {
      path: "/building-twin",
      name: "buildingTwin",
      icon: "mdi-cube-outline",
      color: "teal darken-2",
      component: () => import(/* webpackChunkName: "building-twin" */ "./views/BuildingTwin.vue")
    },
    {
      path: "/heatcontrol",
      alias: "/heatcontrol-multi-apartment",
      name: "heatcontrolConfiguration",
      icon: "mdi-home-group",
      color: "deep-orange darken-1",
      component: HeatcontrolMultiApartment
    },
    {
      path: "/contract",
      name: "contract",
      icon: "assignment_turned_in",
      color: "purple",
      component: Contract
    },
    {
      path: "/unit",
      name: "energyUnit",
      icon: "battery_charging_full",
      color: "green darken-2",
      component: EnergyUnit
    },
    {
      path: "/invoice",
      name: "invoice",
      icon: "description",
      color: "yellow lighten-2",
      component: Invoice
    },
    {
      path: "/administration",
      name: "administration",
      icon: "settings",
      color: "lime lighten-2",
      component: Administration
    },
    {
      path: "/device",
      name: "device",
      icon: "settings",
      color: "red lighten-2",
      component: Device
    },
    {
      path: "/dsgvo",
      name: "Dsgvo",
      component: Dsgvo,
    },
    {
      path: "/user",
      name: "User",
      icon: "settings",
      color: "pink lighten-2",
      component: User
    },
    {
      path: "/pricing",
      name: "Pricing",
      icon: "settings",
      color: "blue lighten-2",
      component: Pricing
    },
    {
      path: "/energy",
      name: "EnergyDashboard",
      icon: "mdi-lightning-bolt",
      color: "cyan",
      component: EnergyDashboard
    },
    {
      path: "/energy-optimizer",
      name: "Energieoptimierung",
      icon: "mdi-battery-charging-outline",
      color: "teal",
      component: EnergyOptimizer
    },
    {
      path: "/notifications",
      name: "Benachrichtigungen",
      icon: "mdi-bell-outline",
      color: "amber darken-2",
      meta: { adminOnly: true },
      component: Notifications
    },
    {
      path: "/messages",
      name: "Nachrichten",
      component: MessagingInbox
    },
    {
      path: "/agents",
      name: "agents",
      icon: "mdi-robot",
      color: "indigo",
      component: Agents
    },
    {
      path: "/workflows",
      name: "workflows",
      icon: "mdi-graph-outline",
      color: "teal",
      component: WorkflowStudio
    },
    {
      path: "/processes",
      name: "processes",
      icon: "mdi-clipboard-flow-outline",
      color: "blue-grey",
      component: ProcessCenter
    },
    {
      path: "/agent-operations",
      name: "agentOperations",
      icon: "mdi-monitor-dashboard",
      color: "deep-purple",
      component: AgentOperations
    },

  ]
});
